<template>
    <div>
        <template v-if="hasButtons">
            <div class="d-print-none">
                <div class="row gx-3 gy-2">
                    <div class="col-auto">
                        <button class="btn btn-primary btn-lg text-uppercase" @click="handleShowSessionsClicked('register')">
                            {{ buttonLabel }}
                            <Icon name="arrow-down" width=".75em" height=".75em" class="align-baseline ml-3" style="transform: rotate(-90deg)" />
                        </button>
                    </div>
                    <template v-if="hasQuoteButton">
                        <div class="col-auto d-print-none">
                            <button class="btn btn-secondary btn-lg text-uppercase" @click="handleShowSessionsClicked('quote')">
                                Je demande un devis
                            </button>
                        </div>
                    </template>
                </div>
            </div>

            <div class="d-none d-print-block">
                <SessionList
                    :course="course"
                    :sessions="course.sessions"
                    :session-route="sessionRoute"
                />
            </div>
        </template>

        <b-modal
            v-model="showRegisterModal"
            dialog-class="course-page__sessions-modal"
            body-class="p-0"
            :hide-footer="course.is_free"
        >
            <template v-slot:modal-title>
                <template v-if="mode === 'quote'">
                    Je demande un devis
                </template>
                <template v-else>
                    {{ buttonLabel }}
                </template>
            </template>

            <SessionList
                :course="course"
                :sessions="sessions"
                :session-route="sessionRoute"
            />

            <template v-slot:modal-footer>
                <div class="small text-muted w-100">
                    (pour les financements par un organisme tiers, le dépôt du dossier doit s’effectuer avant la date limite d’inscription ; par précaution prévoir un délai suffisant)
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
  import Icon from "../../ui/Icon";
  import { hasQuote, registerButtonLabel, sessionRegisterRoute } from "../../../util/register";
  import SessionList from "../../SessionList";
  import Collapse from "../../ui/Collapse";

  export default {
        components: {
            Collapse,
            SessionList,
            Icon,
        },
        props: {
            course: Object,
        },
        data() {
            return {
                showRegisterModal: false,
                mode: 'register',
            }
        },
        computed: {
            hasQuoteButton() {
                return this.quotableSessions.length > 0;
            },
            quotableSessions() {
                return this.course.sessions?.filter(session => hasQuote({ course:this.course, session })) ?? [];
            },
            sessions() {
                return this.mode === 'quote'
                    ? this.quotableSessions
                    : this.course.sessions;
            },
            buttonLabel() {
                return registerButtonLabel(this.course);
            },
            hasButtons() {
                return this.course.registration_level !== 'FREE';
            },
        },
        methods: {
            handleShowSessionsClicked(mode) {
                this.mode = mode;
                this.showRegisterModal = true;
            },
            sessionRoute(session) {
                return sessionRegisterRoute({
                    course: this.course,
                    session,
                    isQuote: this.mode === 'quote',
                })
            },
        },
    }
</script>
